// Plugin
import WOW from 'wow.js';

new WOW().init();
